<template>
    <div style="padding-bottom: 65px; box-sizing: border-box">
        <div
            style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                padding: 0 10px;
                box-sizing: border-box;
            "
        >
            <div style="display: flex; align-items: center; flex-wrap: wrap">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="prev == null ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : firstPage()"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="prev == null ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : prevPage()"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="next == null ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : nextPage()"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="next == null ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : lastPage()"
                />
                <!-- <el-button type="warning" style="margin-left: 10px" icon="el-icon-refresh" size="mini" @click="outData.isshow = true"
                    >{{ $t('common.filter') }}</el-button
                >
                <el-button type="success" style="margin-left: 10px" icon="el-icon-download" size="mini" @click="showOut">{{ $t('common.export') }}</el-button>
                <el-upload
                    style="display: inline-block; float: right; margin-left: 10px"
                    class="biaoge"
                    action=""
                    :on-change="handleChange"
                    :show-file-list="false"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :auto-upload="false"
                >
                    <el-button size="small" type="primary">导入</el-button>
                </el-upload>
                <div style="text-align: right; margin-left: 10px">
                    <el-button type="warning" plain :disabled="isAdd || !isedit" size="mini" @click="checkData.isshow = true"
                        >批量审核</el-button
                    >
                </div> -->
            </div>
            <div style="display: flex; align-items: center; flex-wrap: wrap">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                    >{{ $t('common.add') }}</el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.edit') }}</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delColl"
                    v-if="perData.allow_dele == 1"
                    >{{ $t('common.delete') }}</el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>
                <el-button
                    type="success"
                    size="mini"
                    :disabled="isAdd || !isedit"
                    v-if="perData.allow_add == 1"
                    @click="showImpotDialog = true">
                    Excel导入
                </el-button>
                <el-button
                    type="primary"
                    size="mini"
                    :disabled="isAdd || !isedit || nullBtn"
                    @click="printOut"
                    v-if="perData.allow_print == 1"
                    icon="el-icon-printer"
                    >{{ $t('common.print') }}</el-button
                >
                <el-button type="primary" :disabled="isAdd || !isedit" plain @click="isEdit(form.check)">{{
                    form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                }}</el-button>
            </div>
        </div>
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="top_cols">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="收款单号">
                            <el-input v-model="form.collection_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="收款日期">
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.collection_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <div class="input_col">
                            <el-form-item :label="$t('common.customer') + '：'" required>
                                <mySelectOptimized
                                    v-model="form.cust_no"
                                    :options="allArr.cust"
                                    values="cust_no"
                                    labels="cust_name"
                                    keys="cust_no"
                                    :disable="isedit"
                                    @input="selectCust"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.billType') + '：'" required>
                            <el-select
                                v-model="form.billtype_no"
                                filterable
                                default-first-option
                                clearable
                                @visible-change="getRefreshPull()"
                                @change="refreshs()"
                                placeholder="请选择"
                                :disabled="isedit"
                            >
                                <el-option
                                    v-for="(item, index) in allArr.billtype"
                                    :key="index"
                                    :label="item.billtype_no + ' - ' + item.billtype_name"
                                    :value="item.billtype_no.toString()"
                                    :disabled="item.status == 0"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <div class="input_col">
                            <el-form-item :label="$t('common.salesman') + '：'">
                                <mySelect
                                    v-model="form.salesman_no"
                                    :options="allArr.salesman"
                                    values="salesman_no"
                                    labels="salesman_name"
                                    keys="salesman_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="input_col">
                            <el-form-item :label="$t('common.currency') + '：'" required>
                                <mySelect
                                    v-model="form.currency_no"
                                    :options="allArr.currency"
                                    values="currency_no"
                                    labels="currency_name"
                                    keys="currency_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 6 : 12">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isedit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <div style="position: relative" @mouseleave="dtlleave">
            <div class="table1">
                <div class="title">
                    <div style="text-align: left; color: #000; font-size: 16px; padding: 6px 0">收款明细</div>
                </div>
                <vxe-table
                    border
                    stripe
                    resizable
                    keep-source
                    align="center"
                    ref="xTable1"
                    height="440"
                    :auto-resize="true"
                    show-overflow
                    highlight-hover-row
                    :footer-method="footerMethod"
                    show-footer
                    :loading="loading"
                    :edit-rules="validRules"
                    :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true, enterToTab: true }"
                    :row-class-name="rowChange"
                    :data="form.dtl"
                    :mouse-config="{ selected: true }"
                    :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                    @cell-mouseenter="dtlenter"
                    :key="refushTable"
                >
                    <vxe-table-column type="seq" field="seq" width="72" title="序号">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                                <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                                <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                            </span>
                            <span v-if="scoped.$rowIndex != dtlIndex">
                                <i style="font-style: normal">{{ scoped.seq }}</i>
                            </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in rkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                                name: 'input',
                                attrs: { type: item.column_type },
                                autoselect: true,
                                autofocus: '.vxe-input--inner'
                            }"
                            v-if="item.column_status == 1 && item.column_type != 'select' && item.field != 'trans_amt'"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type)"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                                <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''))"
                                    @keydown.native="jumptable($event, row, item.field)"
                                >
                                    <el-option
                                        v-for="option in allArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                            option[item.field.replace('_no', '') + '_name']
                                        }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            title="换算金额"
                            v-if="item.field == 'trans_amt' && item.column_status == 1"
                            :width="item.column_width"
                            :key="item.field + index"
                            field="trans_amt"
                            :edit-render="{}"
                        >
                            <template v-slot:edit="{ row }">
                                <span>{{ countAmount(row).toFixed(systemSet.amt) }}</span>
                            </template>
                        </vxe-table-column>
                    </template>
                    <template #empty>
                        <span style="color: red">
                            <img src="../../../assets/img/dontHave.png" style="width: 180px" />
                        </span>
                    </template>
                </vxe-table>
            </div>
        </div>
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item label="收款金额：">
                        <p>{{ form.sumamt }}</p>
                    </el-form-item>

                    <el-form-item label="换算金额：">
                        <p>{{ form.sumtrans_amt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.subscribe_no)" style="width: 73px"
                    >{{ $t('common.cancel') }}</el-button
                >
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItCollect">{{ $t('common.save') }}</el-button>
            </div>
        </div>

        <!-- 导出弹出框 -->
        <el-dialog style="padding: 0 20px" :title="$t('common.export')" :visible.sync="excelData.isshow" width="60%">
            <div class="pro" style="text-align: center">
                <el-select
                    style="display: block; width: 50%; margin: 0 auto"
                    v-model="excelValue"
                    clearable
                    default-first-option
                    placeholder="请选择"
                >
                    <el-option label="新收款" value="新收款">新收款</el-option>
                    <el-option label="收款" value="收款">收款</el-option>
                    <el-option label="收款明细" value="收款明细">收款明细</el-option>
                </el-select>
                <el-input style="display: block; width: 50%; margin: 10px auto" v-model="keyword" placeholder="请输入收款单号"></el-input>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="cust_no"
                    placeholder="请选择客户"
                >
                    <el-option
                        v-for="(item, index) in allArr.cust"
                        :key="index"
                        :label="item.cust_name"
                        :value="item.cust_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="currency_no"
                    v-if="excelValue == '收款'"
                    placeholder="请选择货币"
                >
                    <el-option
                        v-for="(item, index) in allArr.currency"
                        :key="index"
                        :label="item.kind_name"
                        :value="item.kind_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <div style="display: block; width: 50%; margin: 0 auto 10px" v-if="excelValue == '收款'">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="collection_date"
                        style="width: 100%"
                    ></el-date-picker>
                </div>
                <div style="display: block; width: 50%; margin: 0 auto 10px" v-if="excelValue == '新收款'">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="开始日期"
                        v-model="collection_date"
                        style="width: 100%"
                    ></el-date-picker>
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="结束日期"
                        v-model="datetimes"
                        style="width: 100%"
                    ></el-date-picker>
                </div>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="bank_no"
                    v-if="excelValue == '收款明细'"
                    placeholder="请选择银行"
                >
                    <el-option
                        v-for="(item, index) in allArr.bank"
                        :key="index"
                        :label="item.kind_name"
                        :value="item.kind_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>

                <el-input
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    v-model="use_no"
                    v-if="excelValue == '收款明细'"
                    placeholder="请输入单号"
                ></el-input>
                <div style="display: flex; align-items: center; margin-top: 30px; justify-content: center">
                    <el-button style="margin-left: 10px" type="success" icon="el-icon-download" @click="outExcel">{{ $t('common.export') }}</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="outTem">模板导出</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="excelData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select v-model="query.model_name" placeholder="请选择模板" filterable clearable @change="selectPrints" style="width: 150px">
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name" :value="item.id">
                </el-option>
            </el-select>
            <div class="printBox" id="print" ref="print" style="page-break-after: always; padding: 10px">
                <div
                    style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                    v-if="DataDtl.company.is_show == 1"
                >
                    <p class="company" v-if="systemSet.company" :style="`font-size:${DataDtl.company.font_size}px;`">
                        {{ systemSet.company }}
                    </p>
                </div>

                <div v-if="DataDtl.title">
                    <div v-if="DataDtl.title.is_show == 1">
                        <p class="printTitle" v-if="printList.billtype_info" :style="`font-size:${DataDtl.title.font_size}px;`">
                            {{ printList.billtype_info.billtype_name }}
                        </p>
                    </div>
                </div>
                <div v-if="DataDtl.header">
                    <div v-if="DataDtl.header.is_show == 1">
                        <div class="printTop" style="margin: 5px 0 10px; padding-bottom: 5px">
                            <div>
                                <div v-if="DataDtl.custno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                    客户编号：{{ printList.cust_no}}
                                </div>
                                <div v-if="DataDtl.custname.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                    客户：{{ printCust.cust_name }}
                                </div>
                                <div v-if="DataDtl.billremark.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                    备注：{{ printList.remark }}
                                </div>
                            </div>
                            <div>
                                <div v-if="DataDtl.billno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                    单据编号：{{  printList.collection_no  }}
                                </div>
                                <div v-if="DataDtl.billdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                    单据日期：{{ printList.collection_date }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="DataDtl.is_fields1 == 1" :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`">
                    <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                        <tr align="center">
                            <template v-for="item in fields1">
                                <template v-if="item.is_show == 1">
                                    <th
                                        :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                            DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                        }`"
                                        :key="item.seq"
                                    >
                                        {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                    </th>
                                </template>
                            </template>
                        </tr>
                        <tr align="center" v-for="(item, index) in printDtl" :key="index">
                            <template v-for="items in fields1">
                                <template v-if="items.is_show == 1">
                                    <td
                                        v-if="items.name == '账户'"
                                        :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${items.align};border:${
                                            DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                        }`"
                                        :key="items.seq"
                                    >
                                        {{ item.bank_info[items.no] || '-' }}
                                    </td>
                                    <td
                                        v-else
                                        :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${items.align};border:${
                                            DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                        }`"
                                        :key="items.seq"
                                    >
                                        {{ item[items.no] || '-' }}
                                    </td>
                                </template>
                            </template>
                        </tr>
                    </table>
                </div>

                <div v-if="DataDtl.is_tot">
                    <div v-if="DataDtl.is_tot.is_show == 1">
                        <div class="oversummoney">
                            <div class="sum1">
                                <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">总计 金额大写</span>
                                <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ printList.money_chinese }}</span>
                            </div>
                            <div class="sum1">
                                <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">金额合计 </span>
                                <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ printList.money }}</span>
                            </div>
                        </div>
                    </div>
                </div>
<!--                <div v-if="yaDtl.custaccounts_now">-->
<!--                    <div-->
<!--                        class="sum2"-->
<!--                        v-if="DataDtl.custaccounts_now.is_show == 1"-->
<!--                        :style="`font-size:${DataDtl.custaccounts_now.font_size}px;`"-->
<!--                    >-->
<!--                        <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">本期存欠帐（正欠负存）:</span>-->
<!--                        <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                            <p-->
<!--                                style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                v-for="(item, index) in printList.custaccounts_now"-->
<!--                                :key="index"-->
<!--                            >-->
<!--                                <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                            </p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div v-if="DataDtl.custaccounts_begin || DataDtl.custaccounts_end || DataDtl.custaccounts_now">
                    <div
                        class="sum2"
                        v-for="(accountConfig, index) in sortedCustAccounts"
                        :key="index"
                        v-if="accountConfig && accountConfig.is_show == 1"
                        :style="`font-size:${accountConfig.font_size}px;`"
                    >
                            <span
                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">{{ accountConfig.label
                                }}:</span>
                        <div style="display: flex; flex-wrap: wrap; width: 80%">
                            <p style="width: 25%; display: flex; justify-content: space-between"
                               v-for="(item, itemIndex) in printList[accountConfig.dataKey]"
                               :key="itemIndex"
                            >
                                <span style="margin-right: 10px">{{ item.style_name }}</span>
                                <span style="font-weight: normal">{{ item.value }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="DataDtl.footer">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                        <div class="sumBotn" style="width: 72%; margin-right: 8%">
                            <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                <span>制单：</span>
                                <span v-if="printList.build_has">{{ printList.build_has.staffr_name }}</span>
                            </div>
                            <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                <span>复核：</span>
                                <span></span>
                            </div>
                            <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                <span>业务员：</span>
                                <span v-if="printList.salesman_report">{{ printList.salesman_report.staffr_name }}</span>
                            </div>
                            <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                <span>客户签名：</span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="text-align: right;">
                    <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                </div>
                <div v-if="DataDtl.remark.is_show == 1">
                    <p :style="`font-size:${DataDtl.remark.font_size}px; white-space: pre-wrap; word-wrap: break-word;`">{{ DataDtl.remark.content }}</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toImg">转图片下载</el-button>
                <el-button type="primary" @click="printContext">直接打印</el-button>
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入单据" :visible.sync="showImpotDialog" width="45%" :before-close="handleClose">
            <div v-loading="uploadLoading" element-loading-text="正在导入数据..." style="min-height: 100px;">
                <div class="importDialogCenter">
                    <div class="centerItem leftItem" @click="outTem">
                        <i class="el-icon-download avatar-uploader-icon"></i>
                        <p class="itemText">点击下载模板</p>
                    </div>
                    <div class="centerItem">
                        <el-upload
                            class="upload-demo"
                            :on-error="uploadError"
                            :on-success="uploadSuccess"
                            :before-upload="beforeUpload"
                            :show-file-list="false"
                            style="width: 100%"
                            :headers="headers"
                            drag
                            :action="this.$baseURL + 'collection_import'"
                            multiple
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                        </el-upload>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    apiFirstCollect,
    apiSearchCollect,
    apiLastCollect,
    apiNextCollect,
    apiPrevCollect,
    apiAllSelectCollect,
    apiModifyCollect,
    apiaddCollect,
    apiDelCollect,
    apiGetinfo,
    apiCurrentPermisson,
    apicheckCollect,
    apichooseCollect,
    apiPrintCollect,
    apiSystem,
    apiCollectImport,
    getPrinOut_pull,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData
} from '@/request/api';
import print from 'print-js';
import html2canvas from 'html2canvas';
import { translateColumns } from '@/utils/columnI18n';
export default {
    name: 'collectmanage',
    data() {
        return {
            printType: '',
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields2: [],
            fields1: [],
            query: {},
            pullList: {},
            bonusData: { field: [], table: [], condition: [], parameter: [] },
            tableIndex: 0,
            tableNo: 0,
            searchData: [],
            arr: [],
            arrs: [],
            cust_no: '',
            bank_no: '',
            currency_no: '',
            collection_date: '',
            use_no: '',
            tableData: [],
            activeName: 'first',
            allArr: '',
            form: {},
            isedit: true,
            isCheck: false,
            prev: null,
            next: null,
            outData: { isshow: false, scope: null, index: 0, data: {} },
            excelData: { isshow: false, scope: null, index: 0, data: {} },
            printData: { isshow: false, scope: null, index: 0, data: {} },
            checkData: { isshow: false, scope: null, index: 0, data: {} },
            keyword: '',
            isAdd: false,
            loading: false,
            excelValue: '',
            pull_cust: [],
            pull_curry: [],
            nullBtn: false,
            printList: {},
            printDtl: [],
            dtlTotal: '',
            checkHas: '',
            printCust: '',
            printCurr: '',
            printBal: '',
            systemSet: '',
            validRules: {
                bank_no: [{ required: true, message: '银行必须填写' }],
                currency_no: [{ required: true, message: '币别必须填写' }]
            },
            username: '',
            printStock: [],
            printStockStart: [],
            printStockend: [],
            datetimes: '',
            dtlIndex: '-1',
            isSave: true,
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '30',
            perData: {}, //权限
            showImpotDialog: false,
            headers: {},
            uploadLoading: false // 上传加载状态
        };
    },
    computed: {
        sortedCustAccounts() {
            const accounts = [];

            if (this.DataDtl.custaccounts_begin) {
                accounts.push({
                    dataKey: 'custaccounts_begin',
                    label: '期初存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_begin.seq || 1,
                    is_show: this.DataDtl.custaccounts_begin.is_show,
                    font_size: this.DataDtl.custaccounts_begin.font_size
                });
            }

            if (this.DataDtl.custaccounts_end) {
                accounts.push({
                    dataKey: 'custaccounts_end',
                    label: '期末存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_end.seq || 2,
                    is_show: this.DataDtl.custaccounts_end.is_show,
                    font_size: this.DataDtl.custaccounts_end.font_size
                });
            }

            if (this.DataDtl.custaccounts_now) {
                accounts.push({
                    dataKey: 'custaccounts_now',
                    label: '本期存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_now.seq || 3,
                    is_show: this.DataDtl.custaccounts_now.is_show,
                    font_size: this.DataDtl.custaccounts_now.font_size
                });
            }

            return accounts.sort((a, b) => a.seq - b.seq);
        }
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
    },
    created() {
        this.getSystem();
        if (this.$route.query.isadd == 0) {
            // this.add();
        } else {
            let bill_no = this.$route.query.bill_no;
            if (bill_no) {
                this.searchIt(bill_no);
            } else {
                this.geData();
            }
        }
        this.getPulls();
        this.getStoneData();
        this.getTable();
        this.getPermission();
        document.addEventListener('keydown', this.mykeyup);

        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.searchIt(bill_no);
        }
    },
    methods: {
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/collectmanage') {
                        this.saveItCollect();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        // 获取页面信息-----------------------------------------
        geData() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.isAdd = false;
            this.isedit = true;
            apiLastCollect({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    }
                } else {
                    loading.close();
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [] };
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiAllSelectCollect({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_cust = res.data.cust;
                    this.pull_curry = res.data.currency;
                    if (this.$route.query.isadd == 0) {
                        this.add();
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 新增客户下拉改变
        selectCust(value) {
            if (value) {
                let item = this.allArr.cust.filter((item) => item.cust_no == value);
                this.$set(this.form, 'salesman_no', item[0].salesman_no);
                this.$forceUpdate();
            }
        },
        // 导入功能
        handleChange(file) {
            let data = new FormData(); //创建form对象
            data.append('file', file.raw);
            data.append('collection_no', this.form.collection_no);
            apiCollectImport(data).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.geData();
                } else {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i].error + '<br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                }
            });
        },
        //搜索-----------------------------------------------------
        searchIt(no) {
            this.isedit = true;
            apiSearchCollect({
                collection_no: no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    this.outData.isshow = false;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            if (no == null) {
                this.geData();
            } else {
                this.searchIt(no);
            }
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/collectmanage');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            this.isSave = true;
            if (this.isedit == true) {
                if (this.form.check == 0) {
                    this.isedit = false;
                    if (this.form.dtl.length == 0) {
                        this.insertEvent(-1);
                    }
                } else if (this.form.check == 1) {
                    this.isCheck = true;
                }
            }
        },
        // 保存修改------------------------------------------
        saveItCollect() {
            if (this.isSave) {
                this.isSave = false;
                //操作失败会删除该单
                let data = this.form;
                var table1 = this.$refs.xTable1.getTableData().fullData;
                table1.forEach((item) => {
                    delete item.custs;
                });
                data['dtl'] = table1;
                data['check'] = this.form.check == true ? '1' : '0';
                this.$load.show();
                if (this.isAdd == true) {
                    apiaddCollect(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/collectmanage');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiModifyCollect(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        //添加产品-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { collection_date: '' };
                setTimeout(() => {
                    for (let i = 0; i < 10; i++) {
                        this.insertEvent(-1);
                    }
                }, 100);
                this.form.check = false;
                this.isCheck = false;
                this.isAdd = true;
                this.nullBtn = false;
                this.form.collection_date = this.$getTime();
                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
            } else {
                this.$message.error('请先保存再添加下一个');
            }
        },
        //删除产品-----------------------------------------
        delColl() {
            this.$confirm('确定要删除该收款管理单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiDelCollect({
                        collection_no: this.form.collection_no
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            if (res.data.data == null) {
                                this.form = {};
                                this.nullBtn = true;
                            } else {
                                this.form = res.data.data;
                                if (this.form.check == 1) {
                                    this.isCheck = true;
                                } else {
                                    this.isCheck = false;
                                }
                            }
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //是否可以编辑修改(审核按钮)------------------------
        isEdit(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apicheckCollect({
                collection_no: this.form.collection_no,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                    this.$message.success(res.msg);
                    this.searchIt(this.form.collection_no);
                } else {
                    this.$message.error(res.data.info);
                    this.searchIt(this.form.collection_no);
                }
            });
        },
        // 跳到第一页-------------------------------------------
        firstPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiFirstCollect({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 跳到最后一页-------------------------------------------
        lastPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiLastCollect({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 下一页-----------------------------------------------------
        nextPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiNextCollect({
                collection_no: this.form.collection_no
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 上一页------------------------------------------
        prevPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrevCollect({
                collection_no: this.form.collection_no
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },

        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                use_no: '',
                bank_no: '',
                rate: '1',
                currency_no: 'CNY',
                remark: '',
                amt: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'use_no', 'bank_no', 'rate', 'currency_no', 'remark', 'amt');
        },

        //回车事件-----------------------------------------
        enterFilterEvent({ $panel, row }, event) {
            if (event.keyCode === 13) {
                this.insertEvent(-1);
            }
        },
        delIt({ $panel, row }, event) {
            if (event.keyCode == 46) {
                this.$refs.xTable1.remove(row);
            }
        },
        //导出excel----------------------------------------
        showOut() {
            this.excelData.isshow = true;
            apiGetinfo({}).then((res) => {
                if (res.code == 2000) {
                    this.username = res.data.login_staff;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        outExcel() {
            var name = this.username;

            this.excelData.isshow = false;
            this.$axios
                .get(this.$baseURL + 'collection_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        collection_no: this.keyword,
                        login_staff: name,
                        type: this.excelValue,
                        cust_no: this.cust_no,
                        bank_no: this.bank_no,
                        currency_no: this.currency_no,
                        collection_date: this.collection_date,
                        use_no: this.use_no,
                        datetime: this.datetimes
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '.xlsx';
                    link.click();
                });
            // }
        },
        // 导入拖拽成功的钩子
        uploadSuccess(res) {
            if (res.code == 2000) {
                this.uploadLoading = false; // 关闭加载动画
                this.$message.success(res.msg);
                this.lastPage();
                this.showImpotDialog = false;
            }  else {
                if (res.data.info instanceof Array) {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i] + '<br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                } else {
                    this.$message.success(res.data.info);
                }
            }
        },
        // 添加上传前的处理函数
        beforeUpload() {
            this.uploadLoading = true; // 开启加载动画
            return true;
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        //导出模板----------------------------------
        outTem() {
            this.$axios
                .get(`${this.$baseURL}template_export_collection`, {
                    params: {
                        type: '单据'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '收款导入模板.xls';
                    link.click();
                });
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        //列配置相关接口

        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '32';
            }
            this.drawers = true;
        },

        checkMove() {},

        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        getTable() {
            apiGetListCorrespondingData({
                id: '32'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                    console.log(this.refushTable, ' this.refushTable');
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //计算金额小计-------------------------
        countAmount(row) {
            var b = Number(row.rate || 0) * Number(row.amt || 0);
            row.trans_amt = b;
            return b;
        },
        //计算金额总计
        countAllAmount(data) {
            return this.$utils.sum(data.map((row) => this.countAmount(row)));
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '35'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        refreshs() {
            this.$forceUpdate();
        },
        // 打印-----------------------
        toImg() {
            html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
                // printJS(
                //   {
                //     printable: url,
                //     type: 'image',
                //     documentTitle: '打印图片'
                //   }
                // )
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile('收款管理.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            //aLink.click()
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        printOut() {
            this.getPulls();
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintCollect({
                collection_no: this.form.collection_no,
                printId: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.dtl[0];
                    this.printDtl = this.printList.dtl_report;
                    this.dtlTotal = this.printList.dtl_total;
                    this.checkHas = this.printList.check_has;
                    this.printCust = this.printList.cust_info || [];
                    this.printCurr = this.printList.currency_info;
                    this.printStock = this.printList.custmtrstock;
                    this.printStockStart = this.printList.custaccounts_begin;
                    this.printStockend = this.printList.custaccounts_end;
                    this.DataDtl = res.data.model_data;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 选择打印下拉框-----------------------
        selectPrints(val) {
            let modelList = this.pullList.model;
            this.printType = modelList.find((item) => item.id == val).name;
            let id = modelList.find((item) => item.id == val).id;
            this.query.model_name = val;
            this.printOutTwo();
            this.$forceUpdate();
        },
        getPulls() {
            let path_code = this.$route.path.replace('/', '');
            getPrinOut_pull({ code: path_code }).then((res) => {
                this.pullList = res.data;
                this.query.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
            });
        },
        printOutTwo() {
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintCollect({
                collection_no: this.form.collection_no,
                printId: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.dtl[0];
                    this.printDtl = this.printList.dtl_report;
                    this.dtlTotal = this.printList.dtl_total;
                    this.checkHas = this.printList.check_has;
                    this.printCust = this.printList.cust_info || [];
                    this.printCurr = this.printList.currency_info;
                    this.printStock = this.printList.custmtrstock;
                    this.printStockStart = this.printList.custaccounts_begin;
                    this.printStockend = this.printList.custaccounts_end;
                    this.DataDtl = res.data.model_data;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.printOut();
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        //处理客户名称回显
        formatStyle(value) {
            if (Object.keys(this.allArr).length > 0) {
                if (value) {
                    let bill = this.allArr.cust.filter((item) => item.cust_no == value);
                    if (bill.length > 0) {
                        return bill[0].cust_name;
                    } else {
                        return value;
                    }
                }
            }
        },
        changeData(row, type) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
        },
        changeData2(row) {
            var newArr = this.allArr.currency.filter(function (obj) {
                return obj.kind_no == row.currency_no;
            });
            if (row.currency_no) {
                row.currency.kind_name = newArr[0].kind_name;
            }
        },
        getRefreshPull() {
            this.pull_cust = this.allArr.cust;
            this.pull_curry = this.allArr.currency;
        },
        // 表尾合计-----------------------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 1) {
                        return '合计';
                    } else if (column.property == 'trans_amt') {
                        this.form.sumtrans_amt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.$forceUpdate();
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'amt') {
                        this.form.sumamt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        getSelectLabel(value, list) {
            if (list) {
                let item = list.find((item) => item.kind_no === value);
                return item ? item.kind_name : null;
            }
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },
        // 新增入库明细
        adddtl() {
            this.insertEvent(-1);
            let length = this.$refs.xTable1.getTableData().fullData.length;
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.xTable1.remove(scoped.row);
        },

        goHistory() {
            this.$router.push({ path: '/collectHistory', query: { page: 'collectmanage' } });
        },
        handleInput(row, field, type) {
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            var jumps = ['trans_amt']; //非输入框列字段
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().tableColumn;
            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;
            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);
            // 最后一列不需要右移
            if (columnIndex + 1 < length) {
                // 获取当前列的下一列
                var downtype = column[columnIndex + 1].property;
                // 不需要填写的跳过
                if (column[columnIndex + 2]) {
                    var downtypes = column[columnIndex + 2].property;
                }
            }

            // 回车键遇到非输入框需要单独处理
            if (e.keyCode == '13' || e.keyCode == '9') {
                if (jumps.indexOf(downtype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, downtype);
                }
                if (rowIndex + 1 == rows.length && columnIndex + 1 == length) {
                    this.insertEvent(-1);
                }
            }
            if (e.keyCode == '39') {
                if (jumps.indexOf(downtype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, downtypes);
                } else {
                    if (columnIndex + 1 == length) {
                        if (rowIndex + 1 == rows.length) {
                            this.insertEvent(-1);
                            rows = this.$refs.xTable1.getTableData().fullData;
                            // 换行
                            setTimeout(() => {
                                this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                            }, 100);
                        } else {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }
                        // // 换行
                        // this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    } else {
                        this.$refs.xTable1.setActiveCell(row, downtype);
                    }
                }
            }
            if (e.keyCode == '37') {
                var uptype = column[columnIndex - 1].property;
                // 不需要填写的跳过
                if (column[columnIndex - 2]) {
                    var uptypes = column[columnIndex - 2].property;
                }

                if (jumps.indexOf(uptype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, uptypes);
                } else {
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
</script>

<style scoped></style>
<style>
.biaoge {
    width: 56px;
    height: 30px;
}
.el-upload--text {
    width: 56px;
    height: 30px;
    border: none;
}

.printBox table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}
.printBox table td,
.printBox table th {
    border: 1px solid #000;
}
.printBox table th {
    font-weight: bold;
    color: #000;
}
.company {
    text-align: center;
    font-size: 16px;
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.printTitle {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: bold;
    letter-spacing: 5px;
}
.printTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 16px;
    color: #000;
    border-bottom: 1px solid rgb(7, 16, 114);
}
.printTop div label {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 15px;
}
.printTop div p {
    line-height: 1.25;
}
.printBox .tableName {
    font-size: 12px;
    padding: 2px 0;
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.oversummoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15% 10px 0;
    border-bottom: 1px solid #000;
}
.oversummoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 15px;
}
.oversummoney .sum1 span:nth-child(2) {
    font-size: 15px;
    color: #000;
    margin-left: 20px;
}
.sumBotn {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 5px 0;
}
.sumBotn p span {
    font-size: 15px;
    color: #000;
}
.sumBotn div span:first-child {
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.sum2 {
    border-bottom: 1px solid rgb(7, 16, 114);
    padding: 1px 0;
    display: flex;
    align-items: flex-start;
}

.sum2 p {
    color: #000;
    font-weight: normal;
    border-right: 1px solid #000;
    padding: 0 5px;
}
.modify {
    background: #eee;
    border-radius: 10px;
    padding-right: 20px;
}
.modify .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
.modify .el-form-item__label {
    padding: 0 0 0 0;
}
.modify .el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0;
    color: #409eff !important;
    padding: 0 0;
}
.modify .el-input.is-disabled .el-input__inner {
    background-color: #eee;
}
.checkboxProOreder {
    margin-top: 5px;
    float: right;
    margin-left: 10px;
}
.checkboxProOreder input[type='checkbox'] {
    width: 17px;
    height: 17px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
    position: relative;
}
.checkboxProOreder input[type='checkbox']::before {
    content: '';
    position: absolute;
    top: -3px;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #d9d9d9;
}
.checkboxProOreder input[type='checkbox']:checked::before {
    content: '\2713';
    background-color: #fff;
    position: absolute;
    top: -3px;
    left: 0;
    width: 100%;
    border: 1px solid #e50232;
    color: #e50232;
    font-size: 17px;
    font-weight: bold;
}
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.box1 .el-select {
    width: 20%;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
.accountD .vxe-table .vxe-body--column.col--ellipsis,
.accountD .vxe-table.vxe-editable .vxe-body--column,
.accountD .vxe-table .vxe-footer--column.col--ellipsis,
.accountD .vxe-table .vxe-header--column.col--ellipsis {
    height: 30px;
}
.accountD .vxe-table .vxe-body--column:not(.col--ellipsis),
.accountD .vxe-table .vxe-footer--column:not(.col--ellipsis),
.accountD .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 5px 0;
}
.accountD tr.vxe-header--row:first-child {
    background: rgb(128, 0, 0);
    color: #fff;
}
.el-select {
    width: 100%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
@media print {
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }
    .printTop div label,
    .oversummoney .sum1 span:nth-child(1),
    .sumBotn p span {
        font-size: 12px;
    }
}
</style>
<style scoped lang="scss">
.footer {
    height: 56px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;
        p {
            width: 150px;
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}
.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .centerItem {
        width: 48%;
        text-align: center;

        /deep/ .el-upload--text {
            width: 100%;
            height: 100%;
        }

        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }

    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;

        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
